<template>

    <section :id="name+'crud'" class="crud">
        <slot></slot>
    </section>

</template>

<script>
    export default {
        props:['name'],
        data() {
            return {}
        },
        watch: {},
        computed: {},
        methods: {},
        mounted() {
            var that = this;
            window.eventBus.$on('crud-show-new-'+this.name,function(){
                window.eventBus.$emit('crud-show-main-'+that.name);
                window.eventBus.$emit('crud-hide-nav-'+that.name);
                window.eventBus.$emit('crud-hide-edit-'+that.name);
                window.eventBus.$emit('crud-hide-view-'+that.name);
            });

            window.eventBus.$on('crud-view-item-'+this.name,function(item){
                window.eventBus.$emit('crud-show-main-'+that.name);
                window.eventBus.$emit('crud-hide-nav-'+that.name);
                window.eventBus.$emit('crud-hide-edit-'+that.name);
                window.eventBus.$emit('crud-hide-new-'+that.name);
            });

            window.eventBus.$on('crud-back-'+this.name,function(item){
                window.eventBus.$emit('crud-hide-nav-'+that.name);
                window.eventBus.$emit('crud-hide-edit-'+that.name);
                window.eventBus.$emit('crud-hide-new-'+that.name);
                window.eventBus.$emit('crud-show-main-'+that.name);
                window.eventBus.$emit('crud-show-view-'+that.name);
                window.eventBus.$emit('crud-view-item-'+that.name,item);
            });

            window.eventBus.$on('crud-back-to-nav-'+this.name,function(){
                window.eventBus.$emit('crud-show-new-'+that.name);
                window.eventBus.$emit('crud-show-nav-'+that.name);
                window.eventBus.$emit('crud-hide-main-'+that.name);
                window.eventBus.$emit('crud-hide-edit-'+that.name);
                window.eventBus.$emit('crud-hide-view-'+that.name);
            });

            window.eventBus.$on('crud-edit-item-'+this.name,function(item){
                window.eventBus.$emit('crud-show-main-'+that.name);
                window.eventBus.$emit('crud-show-edit-'+that.name);
                window.eventBus.$emit('crud-hide-new-'+that.name);
                window.eventBus.$emit('crud-hide-nav-'+that.name);
                window.eventBus.$emit('crud-hide-view-'+that.name);
            });

        }
    }
</script>   

<style lang="scss">
    section.crud{
        @include grid-collapse();
        div.v-select {
            margin-bottom: 0.75em;
        }

        .v-select input {
            font-size: 14px;
            box-shadow:inset 0 1px 3px rgba(0, 0, 0, 0.06);
        }

        .v-select .selected-tag{
            color: #FFF;
            background-color: #6baed1;
            font-size: 14px;
            padding-left: 10px;
            padding-right: 10px;
            line-height:26px;
            border:none;
            border-radius: $standardBorderRadius;
            .close{
                margin-top: -5px;
                margin-left: 4px;
                color: #fff;
                opacity: 0.8;
            }
        }
    }
</style>
